import script from "./esamiFiles.vue?vue&type=script&setup=true&lang=ts"
export * from "./esamiFiles.vue?vue&type=script&setup=true&lang=ts"

import "./esamiFiles.vue?vue&type=style&index=0&id=9d72076c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d72076c"]])

export default __exports__